import useBracketStore from '@/stores/useBracketStore'
import { Button } from '../ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { Label } from '../ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select'

export function JoinBracketDialog() {
  const open = useBracketStore(s => s.showJoinModal)
  const setShowJoinModal = useBracketStore(s => s.setShowJoinModal)
  const availableGroups = useBracketStore(s => s.availableGroups)
  const selectedGroupId = useBracketStore(s => s.selectedGroupId)
  const setSelectedGroupId = useBracketStore(s => s.setSelectedGroupId)
  const joining = useBracketStore(s => s.joining)
  const handleCreateEntry = useBracketStore(s => s.handleCreateEntry)

  return (
    <Dialog open={open} onOpenChange={setShowJoinModal}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create Bracket</DialogTitle>
          <DialogDescription>
            Select which group you want to create a bracket for.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <Label htmlFor="group-select">Group</Label>
          <Select value={selectedGroupId} onValueChange={setSelectedGroupId}>
            <SelectTrigger id="group-select" className="mt-2">
              <SelectValue placeholder="Select a group" />
            </SelectTrigger>
            <SelectContent>
              {availableGroups.map(group => (
                <SelectItem key={group.id || 'global'} value={group.id || 'global'}>
                  {group.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {availableGroups.length === 0 && (
            <p className="text-sm text-muted-foreground mt-2">
              You have already created brackets for all available groups.
            </p>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => setShowJoinModal(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleCreateEntry}
            disabled={joining || availableGroups.length === 0}
          >
            {joining ? 'Creating...' : 'Create Bracket'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export function MissingPicksDialog() {
  const open = useBracketStore(s => s.showMissingPicksModal)
  const setShowMissingPicksModal = useBracketStore(s => s.setShowMissingPicksModal)
  const setMissingPicks = useBracketStore(s => s.setMissingPicks)
  const handleSave = useBracketStore(s => s.handleSave)

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        setShowMissingPicksModal(isOpen)
        if (!isOpen) {
          setMissingPicks([])
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Missing Picks</DialogTitle>
          <DialogDescription>
            Your bracket is incomplete.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => setShowMissingPicksModal(false)}>
            Go Back
          </Button>
          <Button
            onClick={() => {
              setShowMissingPicksModal(false)
              setMissingPicks([])
              void handleSave({ ignoreMissingPicks: true })
            }}
          >
            Save Anyway
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
